export default "__VITE_ASSET__cc111109__"